import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { createDmxProfile } from '../../store/actions';

class CreateDmxDeviceProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      deviceType: 'LED',
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { messageDmxProfile, createDmxProfileError, loadingCreateDmxProfile } = this.props;
    if (loadingCreateDmxProfile === false && prevProps.loadingCreateDmxProfile === true) {
      if (messageDmxProfile) {
        this.setState({ popup: true, pop_msg: 'Perfil creado correctamente' });
      } else if (createDmxProfileError) {
        this.setState({ popup: true, pop_err: createDmxProfileError.message || 'No se ha podido crear el perfil' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.pop_msg) this.props.history.push('/dmxDeviceProfiles');
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.channel_count = Number(values.channel_count);
    values.token = user.token;
    this.props.createDmxProfile(values);
  }

  render() {
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear perfil DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    placeholder={this.props.t('Nombre')}
                    type="text"
                    errorMessage="Introduzca un nombre válido"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="profileName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileDeviceType">{this.props.t('Tipo')}</Label>
                  <AvInput
                    value={this.state.deviceType}
                    name="device_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="profileDeviceType"
                    onChange={(e) => this.setState({ deviceType: e.target.value })}
                  >
                    <option value="LED">LED</option>
                    <option value="SPOTLIGHT">SPOTLIGHT</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="profileChannelCount">{this.props.t('Cantidad de canales')}</Label>
                  <AvField
                    name="channel_count"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="profileChannelCount"
                  />
                </FormGroup>
              </Col>
              <Button color="secondary" type="submit">
                {this.props.t('Crear perfil')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { createDmxProfileError, messageDmxProfile, loadingCreateDmxProfile } = state.createDmxProfile;
  return { createDmxProfileError, messageDmxProfile, loadingCreateDmxProfile };
};

export default withRouter(connect(mapStateprops, { createDmxProfile })(withNamespaces()(CreateDmxDeviceProfileForm)));
